const updates = [
  { time: '07-30', tag: '最新', title: '探花大神七月收官合集正式上线，精选30+优质内容' },
  { time: '07-29', tag: '热门', title: '探花一区「夏日限定」专题持续更新，人气创纪录' },
  { time: '07-28', tag: '推荐', title: '探花91社区本周精选TOP10出炉，神作频现' },
  { time: '07-27', tag: '快讯', title: '探花探花新版索引功能上线，分类查找更高效' },
  { time: '07-26', tag: '公告', title: '平台新增「探花精选」标签体系，内容分级优化' },
  { time: '07-25', tag: '热门', title: '九一探花老牌大神回归，新作引发社区热议' },
  { time: '07-24', tag: '推荐', title: '极品探花月榜TOP20发布，多部口碑佳作入选' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
            动态快讯
          </h2>
          <div className="flex items-center gap-1.5 ml-auto">
            <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></span>
            <span className="text-xs text-foreground-500">实时更新</span>
          </div>
        </div>

        <div className="relative">
          <div className="absolute left-2.5 top-2 bottom-2 w-px bg-background-300"></div>
          <div className="space-y-0">
            {updates.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 py-3 px-1 group">
                <div className="relative z-10 flex items-center justify-center w-5 h-5 shrink-0 mt-0.5">
                  <div className={`w-2.5 h-2.5 rounded-full border-2 border-background-100 ${
                    i === 0 ? 'bg-accent-500' : i < 3 ? 'bg-primary-500' : 'bg-secondary-400'
                  }`}></div>
                </div>
                <div className="flex-1 min-w-0 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-400 font-medium w-10 shrink-0">{item.time}</span>
                  <span className={`inline-flex px-2 py-0.5 rounded text-[10px] font-medium shrink-0 whitespace-nowrap ${
                    item.tag === '最新' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '热门' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '推荐' ? 'bg-secondary-100 text-secondary-700' :
                    'bg-background-200 text-foreground-500'
                  }`}>{item.tag}</span>
                  <p className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors duration-200 leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}